// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"748730c0","544":"0c856a43"}[chunkId] + ".chunk.js";
};